'use client';

import { createTheme } from '@mui/material/styles';

const brand = {
  50: 'hsl(200, 100%, 95%)',
  100: 'hsl(200, 100%, 92%)',
  200: 'hsl(200, 100%, 80%)',
  300: 'hsl(200, 100%, 65%)',
  400: 'hsl(200, 98%, 48%)',
  500: 'hsl(200, 98%, 42%)',
  600: 'hsl(200, 98%, 55%)',
  700: 'hsl(200, 100%, 35%)',
  800: 'hsl(200, 100%, 16%)',
  900: 'hsl(200, 100%, 21%)',
};

const theme = createTheme({
  shape: {
    borderRadius: 8,
  },
  colorSchemes: {
    // light: {
    //   palette: {
    //     primary: {
    //       main: '#ffccbc',
    //     },
    //   },
    // },
    // dark: {
    //   palette: {
    //     primary: {
    //       main: '#ffccbc',
    //     },
    //   },
    // },
    light: {
      palette: {
        primary: {
          light: brand[200],
          main: brand[400],
          dark: brand[700],
          contrastText: brand[50],
        },
      },
    },
    dark: {
      palette: {
        primary: {
          contrastText: brand[50],
          light: brand[300],
          main: brand[400],
          dark: brand[700],
        },
      },
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: 'transparent',
        sx: {
          backdropFilter: 'blur(18px)',
        },
      },
    },
  },
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  typography: {
    fontFamily: 'var(--font-roboto)',
  },
});

export default theme;
